var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"shirt"}},[_c('svg',{ref:"svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"10 0 500 500"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }